import React from "react";
// styled components
import { Modal, Button } from "antd";
// models
interface IProps {
  nombre: string;
  modal: boolean;
  eliminar: any;
  cancelar: any;
  indexExperiencia?: any;
}

export const ModalEliminarExperiencia: React.FC<IProps> = (props: IProps) => {
  return (
    <Modal
      className="modal-eliminar-class"
      style={{ top: 50 }}
      visible={props.modal}
      onOk={() => props.eliminar(props.indexExperiencia)}
      onCancel={props.cancelar}
      width={800}
      footer={[
        <Button key="B_CancelarModalEliminarExp" className="button-gray-ghost" onClick={props.cancelar}>
          CANCELAR
        </Button>,
        <Button key="B_AceptarModalEliminarExp" className="button-azul-radius" onClick={props.eliminar}>
          ACEPTAR
        </Button>,
      ]}
      maskStyle={{
        background: "rgba(162, 103, 95,0.8)",
      }}
    >
      <div className="row mt-4">
        <div className="col-12 font-color-DB2828 font-size-22px text-center justify-content-center">
          ¿Deseas eliminar la publicación?
        </div>
        <div className="col-12 justify-content-center font-family-Montserrat-Regular font-size-14px">
          Estás a punto de eliminar "{props.nombre}"
        </div>
        <div className="col-12 justify-content-center font-family-Montserrat-Bold font-size-14px">
          ¿Deseas eliminarlo?
        </div>
      </div>
    </Modal>
  );
};
